import { productionErrorComment } from './productionErrorComments'

const mapEmployee = (
	employee: { id: string; first_name: string; last_name: string; email: string } | null,
): { id: string; firstName: string; lastName: string; email: string } | null => {
	if (!employee) return null
	return {
		id: employee.id,
		firstName: employee.first_name,
		lastName: employee.last_name,
		email: employee.email,
	}
}

export const productionError = (json: IProductionError): IProductionErrorModel => {
	const {
		id,
		mes_id,
		recipe_id,
		recipe_name,
		recipe_url,
		meal_id,
		meal_name,
		meal_url,
		socket_id,
		socket,
		status,
		type,
		assigned_to_employee_id,
		assigned_to_employee,
		status_changed_by_employee_id,
		status_changed_by_employee,
		status_changed_at,
		last_synced_to_mes_at,
		last_sync_error,
		sync_state,
		reporter_employee_id,
		reporter_employee,
		reporter_name,
		description,
		reported_at,
		production_day,
		variant_id,
		variant_name,
		instructions_preview_img,
		issue_img,
		comments,
		meals_containing_recipe,
		unread_comments_for_crm,
		unread_comments_for_mes,
	} = json

	return {
		id,
		status,
		type,
		mesId: mes_id,
		recipeId: recipe_id,
		recipeName: recipe_name,
		recipeURL: recipe_url,
		mealId: meal_id,
		mealName: meal_name,
		mealURL: meal_url,
		socketId: socket_id,
		socketName: socket?.name ?? '',
		assignedToEmployeeID: assigned_to_employee_id,
		assignedToEmployee: mapEmployee(assigned_to_employee),
		statusChangedByEmployeeId: status_changed_by_employee_id,
		statusChangedByEmployee: mapEmployee(status_changed_by_employee),
		statusChangedAt: status_changed_at ? new Date(status_changed_at) : null,
		lastSyncedToMesAt: last_synced_to_mes_at ? new Date(last_synced_to_mes_at) : null,
		lastSyncError: last_sync_error,
		syncState: sync_state,
		reporterEmployeeId: reporter_employee_id,
		reporterEmployee: mapEmployee(reporter_employee),
		reporterName: reporter_name,
		description: description ?? null,
		reportedAt: new Date(reported_at),
		productionDay: production_day,
		variantId: variant_id,
		variantName: variant_name,
		instructionsPreviewImg: instructions_preview_img ?? null,
		issueImg: issue_img ?? null,
		comments: (comments ?? []).map(comment => productionErrorComment(comment)),
		mealsContainingRecipe: meals_containing_recipe,
		unreadCommentsForCrm: unread_comments_for_crm ?? 0,
		unreadCommentsForMes: unread_comments_for_mes ?? 0,
	}
}
